import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { Observer } from 'mobx-react'

// Routes
import Main from './routes/Main'
import { withAuth } from './components'
import { authenticatedUserStore } from './stores'

function App() {
    return (
        <Observer>
            {() => {
                // access the permissions here so that the page is re-rendered
                // if the token changes (via impersonating)
                // eslint-disable-next-line
                let permissions = authenticatedUserStore.permissions
                return (
                    <Router>
                        <Route path="/" component={withAuth(Main)} />
                    </Router>
                )
            }}
        </Observer>
    )
}

export default App
